import React from 'react'
import { Button } from "../Buttons";

/**
 * AddRowBtn - Button for adding a new row with wrapper styling
 * 
 * @param {Object} props
 * @param {function} props.onClick - Click handler
 * @param {Object} props.style - Additional wrapper styles
 * 
 * @example
 * <AddRowBtn onClick={handleAddRow} />
 */
const AddRowBtn = ({onClick, style}) => {
  return (
    <div style={{ marginTop: "-50px", ...style, paddingLeft: "15px" }}>
      <Button
        onClick={onClick}
        variant="gray"
        size="sm"
        style={{ width: "100px" }}
      >
        + Add Row
      </Button>
    </div>
  );
}

export default AddRowBtn